import { render, staticRenderFns } from "./regulation-policy.vue?vue&type=template&id=09013205"
import script from "./regulation-policy.vue?vue&type=script&lang=js"
export * from "./regulation-policy.vue?vue&type=script&lang=js"
import style0 from "./regulation-policy.vue?vue&type=style&index=0&id=09013205&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports